import { InfinitySpin } from "react-loader-spinner";

export interface LoadingProps {}

export function Loading(props: LoadingProps) {
  return (
    <div>
      <div className="w-full h-full bg-black loader opacity-40"></div>
      <div className="absolute top-1/3 left-1/2">
        <InfinitySpin width="200" color="var(--color-mk-primary-bright)" />
      </div>
    </div>
  );
}
